import api from './axiosConfig';
import { handleApiError } from './errorHandler';

export const wasteReportAPI = {
    getReport: async (days, categories, search) => {
        try {
            const { data } = await api.get('/api/reports/waste-percentage/', {
                params: { days, categories, search }
            });
            return data;
        } catch (error) {
            handleApiError(error, 'Get waste percentage report error:');
        }
    }
};
